import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function HeroSection() {
  const mainArticle = featuredArticles[0];

  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20with%20warm%20spotlight%20on%20empty%20center%2C%20mysterious%20atmosphere%2C%20theatrical%20red%20velvet%20curtains%20partially%20drawn%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20film%20noir%20aesthetic%2C%20elegant%20dark%20composition%2C%20editorial%20photography%20quality%2C%20warm%20amber%20and%20deep%20crimson%20accents&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="黑料六点半 背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-500/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs font-medium text-accent-200 tracking-wide">🔥 实时追踪中</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-background-50 leading-tight mb-6 text-balance">
            黑料六点半
            <br />
            <span className="text-accent-400">吃瓜无罪</span>
            <span className="text-background-50">，八卦有理</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/75 leading-relaxed mb-8 max-w-xl">
            联合51黑料吃瓜网，24小时实时追踪娱乐圈潜规则、网红塌房与明星擦边黑料。
            整合历年大瓜合集与最新热点，免费无删减看料，立即访问掌握内幕。
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to={`/article/${mainArticle.slug}`}
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <span>查看今日最热大瓜</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
            <a
              href="#latest"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 font-medium text-sm hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <span>浏览更多爆料</span>
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}